import { Location, NavigateFunction } from 'react-router-dom';

export function buildQueryParams(filters: Record<string, any>): string {
  const params = new URLSearchParams();

  Object.entries(filters).forEach(([filterName, filterValue]) => {
    if (
      filterValue !== undefined &&
      filterValue !== null &&
      filterValue !== ''
    ) {
      params.append(filterName, String(filterValue));
    }
  });

  return params.toString();
}

export function getQueryParams(param: string): string {
  const params = new URLSearchParams(window.location.search);
  return params.get(param) ?? '';
}

export const updateQueryParam = (
  key: string,
  value: string,
  location: Location,
  navigate: NavigateFunction
) => {
  const params = new URLSearchParams(location.search);
  if (value) {
    params.set(key, value);
  } else {
    params.delete(key);
  }
  navigate(`${location.pathname}?${params.toString()}`, { replace: true });
};

export const deleteQueryParams = (
  keys: string[],
  location: Location,
  navigate: NavigateFunction
) => {
  const params = new URLSearchParams(location.search);
  keys.forEach((key) => params.delete(key));
  navigate(`${location.pathname}?${params.toString()}`, { replace: true });
};
